<template>
  <div class="m-0 p-0" v-on-clickaway="away">
    <div class="row" v-if="this.isEmpty">
      <div class="col-12">
          <div class="blank-content">
            <h3>Pour commencer, ajoutez un conteneur</h3>
            <h4>Le procéssus de génération commence toujours par des conteneurs, puis des colonnes, puis des éléments</h4>
            <b-button
              @click="addConteneur"
              variant="outline-primary"
            >
              <font-awesome-icon :icon="['fas', 'plus']" /> Conteneur
            </b-button>
          </div>
      </div>
    </div>

      <draggable :list="elements"  v-else  handle=".move-action-con">
        <div class="row" role="conteneur"v-for="(element, index) in elements"  :id="'conteneur-'+index" :key="'conteneur-'+index" :class="{columnSelectedClass: columnSelectedClass }"
             :style="[typeof wrapperStyle[index]  !== 'undefined' ? wrapperStyle[index] : element.style]">
            <div class="top-action">
                  <span class="my-btn-group inactive d-none">
                      <button
                              class="h-100 d-none trash-icon"
                              @click="deleteConteneur(index)"
                      ><font-awesome-icon :icon="['fas', 'trash-alt']" /></button>
                      <b-button
                              class="move-action-con"
                              v-b-popover.hover.top="'Déplacer la colonne'">
                          <font-awesome-icon :icon="['fas', 'expand-arrows-alt']" />
                      </b-button>
                      <button
                              @click="activateContainer(index, $event, element, index)"
                      >
                          <font-awesome-icon :icon="['fas', 'edit']" /></button>
                  </span>
            </div>
            <div class="container-controls d-none for-container">
              <ul>
                  <li>
                      <b-button @click="handleColonneClick('col-12', index)" class="btn-item">
                          <div class="h-100 choice">
                              1/1
                          </div>
                      </b-button>
                  </li>
                  <li>
                      <b-button @click="handleColonneClick('col-6', index)" class="btn-item">
                          <div class="h-100  choice">
                              1/2
                          </div>
                      </b-button>
                  </li>
                  <li>
                      <b-button @click="handleColonneClick('col-3', index)" class="btn-item">
                          <div class="h-100 choice">
                              1/4
                          </div>
                      </b-button>
                  </li>
                  <li>
                      <b-button @click="handleColonneClick('col-9', index)" class="btn-item">
                          <div class="h-100  choice">
                              3/4
                          </div>
                      </b-button>
                  </li>
                  <li>
                      <b-button  @click="handleColonneClick('col', index)" class="btn-item">
                      <div class="h-100  choice">
                          Auto
                      </div>
                  </b-button></li>
                  <li>
                      <b-button  @click="addConteneur(index)" class="btn-item">
                          <div class="h-100  choice">
                              <font-awesome-icon :icon="['fas', 'plus']" />
                          </div>
                      </b-button>
                  </li>
              </ul>
          </div>
          <div class="col-12 px-0" v-if="element.type !== 'header' && element.type !== 'fiche_data'">
              <div class="empty-section" v-if="!element.childElements.length"  @click="activateContainer(index, $event, element, index)"  >
                Pour ajouter des Eléments, vous devez d'abord ajouter des Colonnes
              </div>
              <list-colonne v-else
                class="row px-0 mx-0" role="colonne"
                :colonnes="element.childElements"
                :conindex="index"
              ></list-colonne>
          </div>
        </div>
      </draggable>
    <edit-wrapper

      ref="editWrapper"
    />
  </div>
</template>

<script>
import selectionColonne from '../modal/selectionColonne'
import { mapActions } from 'vuex'
import draggable from 'vuedraggable'
import listColonne from './listColonne'
import editWrapper from '../modal/editWrapper'
import { directive as onClickaway } from 'vue-clickaway'
import {eventBus} from '../../../main'
export default {
  components: {
    listColonne,
    selectionColonne,
    draggable,
    editWrapper
  },
  mounted () {
    eventBus.$on('setMyStyle', data => {
      this.wrapperStyle[this.wrapperIndex] = JSON.parse(JSON.stringify(data.style))
      this.wrapperIndex = data.index
      this.wrapper = data.wrapper

      setTimeout(() => {
        eventBus.$emit('selected', {
          elements: this.elements,
          index: this.wrapperIndex,
          type: 'conteneur'
        })
      }, 500)

      this.handleWrapperUpdate(this)
    })
  },
  data () {
    return {
      wrapper: null,
      wrapperStyle: [],
      wrapperIndex: null,
      currentElement: null,
      columnSelectedClass: false,
      showTrash: false
    }
  },
  props: {
    elements: {
      type: Array,
      default: () => ([])
    }
  },
  directives: {
    onClickaway: onClickaway
  },
  computed: {
    isEmpty () {
      return this.elements.length === 0
    }
  },
  methods: {
    ...mapActions(['addFicheConteneur', 'deleteFicheConteneur', 'addFicheColonne', 'updateConteneur']),
    onStyleApplied (data) {
      this.wrapperStyle = data.style
      this.wrapperIndex = data.index
    },
    activateContainer (id, event, element, index) {
      var elem = document.getElementById('conteneur-' + id)

      eventBus.$emit('selected', {
        elements: this.elements,
        index: index,
        type: 'conteneur'
      })

      this.currentElement = element
      this.wrapperIndex = index

      var elems = document.querySelectorAll('[role="conteneur"]')

      if (elems.length > 0) {
        for (let i = 0; i < elems.length; i++) {
          elems[i].classList.remove('container-active')
          elems[i].classList.remove('columnSelectedClass')
        }
      }

      var containerControls = document.querySelectorAll('.container-controls')
      for (let j = 0; j < containerControls.length; j++) {
        containerControls[j].classList.add('d-none')
      }

      var btngroups = document.querySelectorAll('.my-btn-group')
      for (let k = 0; k < btngroups.length; k++) {
        btngroups[k].classList.add('inactive')
      }

      var cedit = document.querySelectorAll('.cedit')

      if (cedit.length > 0) {
        for (var j = 0; j < cedit.length; j++) {
          cedit[j].classList.remove('thecolselected')
        }
      }

      var btngroups = document.querySelectorAll('.my-btn-group')
      for (let k = 0; k < btngroups.length; k++) {
        btngroups[k].classList.add('inactive')
      }

      var handle = document.querySelectorAll('.the-handle')

      if (handle.length > 0) {
        for (var j = 0; j < handle.length; j++) {
          handle[j].classList.remove('show')
        }
      }

      elem.querySelector('.container-controls').classList.remove('d-none')
      elem.classList.add('container-active')
      elem.querySelector('.trash-icon').classList.remove('d-none')
      elem.querySelector('.top-action').classList.remove('d-none')
      elem.querySelector('.my-btn-group').classList.remove('inactive')
      elem.querySelector('.my-btn-group').classList.remove('d-none')

      console.log('dasdsa')
      this.disableActiveColumns()

      eventBus.$emit('enableToolbarButtons')
    },
    away (e) {
      // Add some control to keep container selected.
      let path = e.path
      let unhighlight = true

      for (let x = 0; x < path.length; x++) {
        if (typeof path[x].classList !== 'undefined' && path[x].classList.contains('btn-toolbar')) {
          unhighlight = false
          break
        }
      }

      if (document.getElementById('background-color-picker').querySelector('ul').classList.contains('show')) {
        unhighlight = false
      }

      if (document.getElementById('font-color-picker').querySelector('ul').classList.contains('show')) {
        unhighlight = false
      }

      if (unhighlight === false) {
        return
      }

      // Disable toolbar buttons
      eventBus.$emit('disableToolbarButtons')

      var elems = document.querySelectorAll('[role="conteneur"]')

      for (let i = 0; i < elems.length; i++) {
        elems[i].classList.remove('container-active')
        elems[i].classList.remove('columnSelectedClass')
        elems[i].querySelector('.container-controls').classList.add('d-none')
        elems[i].querySelector('.my-btn-group').classList.add('inactive')
        elems[i].querySelector('.my-btn-group').classList.add('d-none')
        elems[i].querySelector('.trash-icon').classList.add('d-none')
      }

      var activeElem = document.querySelectorAll('.active')

      for (let a = 0; a < activeElem.length; activeElem++) {
        activeElem[a].classList.remove('active')
      }

      this.disableActiveColumns()
    },
    disableActiveColumns () {
      var activeColumns = document.querySelectorAll('.columnActive')

      if (activeColumns.length > 0) {
        for (var j = 0; j < activeColumns.length; j++) {
          activeColumns[j].classList.remove('columnActive')
        }
      }
    },
    colonneClick (colSize, conteneurIndex) {
      this.$emit('colonneClick', { colSize, index: conteneurIndex })
    },
    addConteneur (index = null) {
      this.addFicheConteneur(index)
    },
    deleteConteneur (index) {
      this.deleteFicheConteneur(index)
    },
    handleColonneClick (colSize, conteneurIndex) {
      var data = { colSize, index: conteneurIndex }
      this.addFicheColonne(data)
    },
    openColonneSelectionModal (index) {
      this.$refs['selectionColonne' + index][0].open()
    },
    openEditWrapperModal (data) {
      this.$refs['editWrapper'].open(data)
    },
    handleWrapperUpdate (data) {
      this.updateConteneur({conindex: data.wrapperIndex, data: data.wrapper})
    }
  }
}
</script>

<style lang="scss" scoped>
    .columnSelectedClass .my-btn-group.inactive{
        display: inline !important;
        opacity: 0.2;
    }
    .columnSelectedClass .my-btn-group.inactive:hover {
        opacity: 1;
    }
    .container-active .my-btn-group {
        display: inline !important;
    }

    .top-action{
        top: -28px;
        right: 15px;
        left: 0;
        color: white;
        position: absolute;
        width: 100%;
        height: 25px;
        text-align: center;
        border-radius: 3px;

        .my-btn-group {
            padding: 2px;
            background: #9395C1;
        }
        .my-btn-group.inactive {
            background: #7F7F7F;
            opacity: 0.2;
        }
        button{
            background-color:  transparent;
            border: none;
            font-size: 14px;
            color: white;
            padding-left: 3px;
            padding-right: 3px;
        }
        button:hover{
            background-color: transparent;
        }
    }
    .container-active, .columnActive {
        /*border:2px solid #9395C1;*/
        box-shadow: 0 0 2px 3px #9395C1;
    }

    .columnSelectedClass {
        box-shadow: 0 0 1px 1px #ccc;
    }

    .container-controls {
        position:absolute;
        right:-34px;
    }
    .container-controls ul {
        padding:0;
        margin:0;
    }
    .container-controls li {
        display:block;
        margin:-3px;
    }

    .container-controls li button {
        background:#9395C1;
        padding: 0 5px;
        font-size:11px;
        color:#fff;
        border-radius:0;
        width:35px;
    }

    .container-controls li button div {
        text-align:center;
        line-height: 20px;
        border-radius:0;
    }

  .blank-content{
    margin: 5em 0;
    text-align: center;
    color: #777;
    h3{
      color: #23282d;
      margin: 1em 0;
      font-size: 16px;
      font-weight: bold;
    }
    h4{
      color: #555d66;
      font-weight: 400;
      line-height: 1;
      font-style: italic;
      margin: -7px 0 28px;
      font-size: 14px;
    }
  }

  .row[role="conteneur"]{
        /*margin-left: 12px;*/
        /*margin-right: 12px;*/
        /*margin-top: 35px;*/
        position:relative;
        right: -34px;
    .row[role="colonne"]{

      /*padding-top: 5px;*/
      /*padding-bottom: 41px;*/
    }
    .empty-section{
      font-size: 24px;
      line-height: 30px;
      top: 50%;
      width: 100%;
      color: rgba(0, 0, 0, 0.4);
      text-align: center;
      margin: 5em 0;
    }
    .bottom-action{
      bottom: 0;
      right: 0;
      position: absolute;
      button{
        text-align: center;
        background-color: white;
        color:  #fff;
        border: 1px solid #2b3085;
        background-color: #2b3085;
        padding: 0px 0;
        width: 160px;
        height: 25px;
        font-size: 14px;
      }
      button:hover{
        color: #2b3085;
        background-color: #fff;
        border-color: #2b3085;
      }
    }
  }

    .container-active > .top-action.d-none {
        display:inline-block !important;
    }

    .container-active > .for-container.d-none {
        display:inline-block !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/ficheEspace/edit/conteneur.vue